import {
  UnreadBadge,
  MentionIcon,
  MessageStatusSingle,
  MessageStatusGroup,
  MessageLuckyBoxIcon,
} from '@halo/ui-chat-react';
import { Center, HStack } from '@chakra-ui/react';
import { MsgAtFlag, type Msg, type SessionOperate } from '@halo/chat-sdk';

interface ChatMetaExtraProps {
  isGroup: boolean;
  unreadCount: number;
  mutedUnreadCount: number;
  hasMention?: boolean;
  isLuckyBox?: boolean;
  lastMessage?: Msg;
  isMyMessage?: boolean;
  isSystemMsg?: boolean;
  operateAccess?: Record<keyof typeof SessionOperate, boolean>;
  isCollapseChat?: boolean;
}

export function ChatMetaExtra({
  isGroup,
  lastMessage,
  unreadCount,
  mutedUnreadCount,
  hasMention,
  isLuckyBox,
  isMyMessage,
  isSystemMsg,
  operateAccess,
}: ChatMetaExtraProps) {
  const renderMentionIcon = useMemo(() => {
    const hasAtMe = hasMention && lastMessage?.at_flag === MsgAtFlag.AtMe;
    const hasAtAll = hasMention && !operateAccess?.MUTED_AT_ALL;
    if (hasAtMe || hasAtAll) {
      return <MentionIcon />;
    }
    return null;
  }, [hasMention, lastMessage?.at_flag, operateAccess?.MUTED_AT_ALL]);

  return (
    <HStack className="ChatMetaExtra" align="center" gap="1" ml="1">
      {isLuckyBox && (
        <Center w="1.4em">
          <MessageLuckyBoxIcon />
        </Center>
      )}
      {isMyMessage &&
        !isSystemMsg &&
        (isGroup ? (
          <MessageStatusGroup
            status={lastMessage?.status}
            readCount={lastMessage?.read_state?.read_count}
            totalCount={lastMessage?.read_state?.total_count}
            processScale={0.9}
            color="var(--colors-fg-muted)"
          />
        ) : (
          <MessageStatusSingle
            status={lastMessage?.status}
            receiptStatus={lastMessage?.receipt_status}
            processScale={0.8}
          />
        ))}
      {renderMentionIcon}
      <UnreadBadge count={unreadCount} mutedCount={mutedUnreadCount} />
    </HStack>
  );
}
